(function () {
  'use strict';

  if (window.bsbCardSwatchesInitialized) return;
  window.bsbCardSwatchesInitialized = true;

  const status = document.createElement('p');
  status.className = 'visually-hidden';
  status.setAttribute('aria-live', 'polite');
  status.setAttribute('aria-atomic', 'true');
  document.body.append(status);

  function formatPrice(cents) {
    const amount = cents / 100;
    const hasFraction = amount % 1 !== 0;
    return '$' + amount.toLocaleString(undefined, {
      minimumFractionDigits: hasFraction ? 2 : 0,
      maximumFractionDigits: 2,
    });
  }

  const observedRows = new WeakSet();
  const rowObserver = typeof ResizeObserver === 'undefined'
    ? null
    : new ResizeObserver((entries) => {
      entries.forEach(({ target }) => updateRowAlignment(target));
    });

  function updateRowAlignment(row) {
    if (!row) return;
    const price = row.querySelector('.bsb-fc__price');
    const rowRight = row.querySelector('.bsb-fc__row-right');
    if (!price || !rowRight) return;
    row.classList.remove('is-wrapped');
    row.classList.toggle('is-wrapped', rowRight.offsetTop > price.offsetTop);
  }

  function initializeRowAlignment() {
    document.querySelectorAll('.bsb-fc__row').forEach((row) => {
      updateRowAlignment(row);
      if (rowObserver && !observedRows.has(row)) {
        observedRows.add(row);
        rowObserver.observe(row);
      }
    });
  }

  initializeRowAlignment();

  document.addEventListener('click', (event) => {
    const swatch = event.target.closest('[data-bsb-card-swatch]');
    if (!swatch) return;

    event.preventDefault();
    event.stopPropagation();

    const card = swatch.closest('[data-bsb-swatch-card]');
    if (!card) return;

    card.querySelectorAll('[data-bsb-card-swatch]').forEach((button) => {
      const isActive = button === swatch;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', String(isActive));
    });

    const url = swatch.dataset.variantUrl;
    if (url) {
      card.querySelectorAll('[data-bsb-card-link]').forEach((link) => link.setAttribute('href', url));
    }

    const price = Number(swatch.dataset.price);
    const compareAtPrice = Number(swatch.dataset.compareAtPrice);
    const priceElement = card.querySelector('[data-bsb-card-price] .bsb-price');
    if (priceElement && Number.isFinite(price) && window.bsbPrice) {
      window.bsbPrice.render(priceElement, price, compareAtPrice);
      updateRowAlignment(card.querySelector('.bsb-fc__row'));
    }

    const image = card.querySelector('[data-bsb-card-image], .bsb-fc__img, .bsb-pt__img');
    if (image && swatch.dataset.image) {
      image.src = swatch.dataset.image;
      image.srcset = '';
    }

    const color = swatch.getAttribute('aria-label');
    const priceLabel = Number.isFinite(price) ? `, from ${formatPrice(price)}` : '';
    status.textContent = `${color} selected${priceLabel}.`;
  });

})();
